import { useEffect } from 'react'
import { Box } from '@lounge-fe/ui-kit'
import { DiscountModalTriggerProps } from './types'
import { useDiscountModalStore } from './store'

export const DiscountModalTrigger = ({
  as,
  children,
  className,
}: DiscountModalTriggerProps) => {
  const { open, hasSignedUp, checkSignupStatus } = useDiscountModalStore()

  useEffect(() => {
    checkSignupStatus()
  }, [checkSignupStatus])

  if (hasSignedUp) return null

  return (
    <Box as={as} onClick={open} className={className}>
      {children}
    </Box>
  )
}
